var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.readyForRender
    ? _c("div", [
        _c("div", { staticClass: "form-group mt-3 mb-2" }, [
          _c("table", { staticClass: "table tablerow" }, [
            _c("caption", [
              _c(
                "h2",
                [
                  _c("plain-text-control", {
                    attrs: {
                      title: "PaymentPlan.Payments.Title",
                      required: true
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _c(
                    "span",
                    { attrs: { id: "paymentdate_header" } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("PaymentPlan.Payments.PaymentDate")) +
                          "\n              "
                      ),
                      _c("tooltip-icon", {
                        attrs: {
                          content: _vm.$t(
                            "PaymentPlan.Payments.PaymentDate_Instructions"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        _vm._s(_vm.paymentDateRangeString) + "\n            "
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "right" }, [
                  _c("span", { attrs: { id: "personnelexpenses_header" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("PaymentPlan.Payments.PersonnelExpenses"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "right" }, [
                  _c("span", { attrs: { id: "premiseexpenses_header" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("PaymentPlan.Payments.PremiseExpenses"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "right" }, [
                  _c("span", { attrs: { id: "operationalexpenses_header" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("PaymentPlan.Payments.OperationalExpenses"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "right" }, [
                  _c("span", { attrs: { id: "generalexpenses_header" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("PaymentPlan.Payments.GeneralExpenses"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "right" }, [
                  _c("span", { attrs: { id: "totalexpenses_header" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("toUpperCase")(
                          _vm.$t("PaymentPlan.Payments.TotalExpenses")
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("th", { attrs: { id: _vm.$attrs.id + "_actions" } }, [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.requests, function(request, index) {
                return _c(
                  "tr",
                  { staticClass: "paddingless" },
                  [
                    _c(
                      "td",
                      { staticClass: "input-cell center w-15" },
                      [
                        _c("date-input-row", {
                          class: _vm.$attrs.id + "-" + index,
                          attrs: {
                            name: "requestdate" + index,
                            required: true,
                            placeholder: _vm.$t(
                              "DatePicker.FormatPlaceholderFull"
                            ),
                            rules: {
                              required: true,
                              within: [_vm.minPaymentDate, _vm.maxPaymentDate]
                            },
                            fullDate: true,
                            labelledBy: "paymentdate_header"
                          },
                          on: {
                            input: function($event) {
                              return _vm.emitDateChange()
                            }
                          },
                          model: {
                            value: request.date,
                            callback: function($$v) {
                              _vm.$set(request, "date", $$v)
                            },
                            expression: "request.date"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("numeric-input-table-cell", {
                      attrs: {
                        classes: ["input-cell"],
                        name: "personnelExpenses" + index,
                        required: _vm.getRowRequired(request),
                        disabled: _vm.$attrs.disabled,
                        placeholderKey: "EnterValue",
                        labelledBy: "personnelexpenses_header"
                      },
                      model: {
                        value: request.personnelExpensesAmount,
                        callback: function($$v) {
                          _vm.$set(request, "personnelExpensesAmount", $$v)
                        },
                        expression: "request.personnelExpensesAmount"
                      }
                    }),
                    _vm._v(" "),
                    _c("numeric-input-table-cell", {
                      attrs: {
                        classes: ["input-cell"],
                        name: "premiseExpenses" + index,
                        required: _vm.getRowRequired(request),
                        disabled: _vm.$attrs.disabled,
                        placeholderKey: "EnterValue",
                        labelledBy: "premiseexpenses_header"
                      },
                      model: {
                        value: request.premiseExpensesAmount,
                        callback: function($$v) {
                          _vm.$set(request, "premiseExpensesAmount", $$v)
                        },
                        expression: "request.premiseExpensesAmount"
                      }
                    }),
                    _vm._v(" "),
                    _c("numeric-input-table-cell", {
                      attrs: {
                        classes: ["input-cell"],
                        name: "operationalExpenses" + index,
                        required: _vm.getRowRequired(request),
                        disabled: _vm.$attrs.disabled,
                        placeholderKey: "EnterValue",
                        labelledBy: "operationalexpenses_header"
                      },
                      model: {
                        value: request.operationalExpensesAmount,
                        callback: function($$v) {
                          _vm.$set(request, "operationalExpensesAmount", $$v)
                        },
                        expression: "request.operationalExpensesAmount"
                      }
                    }),
                    _vm._v(" "),
                    _c("numeric-input-table-cell", {
                      attrs: {
                        classes: ["input-cell"],
                        name: "generalExpenses" + index,
                        required: _vm.getRowRequired(request),
                        disabled: _vm.$attrs.disabledy,
                        placeholderKey: "EnterValue",
                        labelledBy: "generalexpenses_header"
                      },
                      model: {
                        value: request.generalExpensesAmount,
                        callback: function($$v) {
                          _vm.$set(request, "generalExpensesAmount", $$v)
                        },
                        expression: "request.generalExpensesAmount"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "right disabled-background w-10" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatNumber")(_vm.requestTotal(request))
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        class: [
                          "w-5",
                          _vm.isReadOnly ? "disabled-background" : ""
                        ]
                      },
                      [
                        _c("span", { staticClass: "centered" }, [
                          _vm.showDelete && !_vm.isReadOnly
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-link btn-contrast",
                                  attrs: {
                                    type: "button",
                                    "aria-label":
                                      _vm.$t("Btn_DeleteRow") +
                                      (index + 2) +
                                      " -. " +
                                      _vm.$t("Accessibility.ConfirmDeleteRow")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteRow(request)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-trash-alt fa-lg centered"
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("tfoot", [
              _c("tr", [
                _c("td", { staticClass: "disabled-background" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total"))))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background right" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatNumber")(_vm.totals.personnelExpensesAmount)
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background right" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatNumber")(_vm.totals.premiseExpensesAmount)
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background right" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatNumber")(
                        _vm.totals.operationalExpensesAmount
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background right" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatNumber")(_vm.totals.generalExpensesAmount)
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background right" }, [
                  _vm._v(
                    _vm._s(_vm._f("formatNumber")(_vm.requestTotal(_vm.totals)))
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background" })
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        !_vm.isReadOnly
          ? _c("div", [
              _vm.enableAddButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.addRow()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("BudgetaryEstimate.Btn_AddRow")) +
                          "\n    "
                      )
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { disabled: "", "aria-disabled": "true" }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("BudgetaryEstimate.Btn_AddRow")) +
                          "\n    "
                      )
                    ]
                  )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }